import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * lead-capture operation
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const captureLead = async ({
  request,
}: {
  request: ApiTypes["lead-capture"]["request"];
}): Promise<ApiTypes["lead-capture"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["lead-capture"]["response"]
    >(`/api/public/v2025-06/events/leads/capture`, request);
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to captureLead");
    throw error;
  }
};
